import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryItem = createRoutine('FETCH_INVENTORY_ITEM');
export const fetchInventoryItems = createRoutine('FETCH_INVENTORY_ITEMS');
export const createInventoryItem = createRoutine('CREATE_INVENTORY_ITEM');
export const updateInventoryItem = createRoutine('UPDATE_INVENTORY_ITEM');
export const deleteInventoryItem = createRoutine('DELETE_INVENTORY_ITEM');
export const importInventoryItem = createRoutine('IMPORT_INVENTORY_ITEM');
export const addInventoryItemSku = createRoutine('ADD_INVENTORY_ITEM_SKU');

export const fetchInventoryItemSkus = createRoutine(
  'FETCH_INVENTORY_ITEM_SKUS'
);
export const deleteInventoryItemSku = createRoutine(
  'DELETE_INVENTORY_ITEM_SKU'
);

export const importInventoryItemQuantity = createRoutine(
  'IMPORT_INVENTORY_ITEM_QUANTITY'
);

export const fetchInventoryItemAvailability = createRoutine(
  'FETCH_INVENTORY_ITEM_AVAILABILITY'
);

export const deleteInventoryItemAvailability = createRoutine(
  'DELETE_INVENTORY_ITEM_AVAILABILITY'
);

export const fetchInventoryItemsAvailability = createRoutine(
  'FETCH_INVENTORY_ITEMS_AVAILABILITY'
);

export const fetchInventoryExportUrl = createRoutine(
  'FETCH_INVENTORY_EXPORT_URL'
);

export const fetchInventoryItemsTemplateDownloadUrl = createRoutine(
  'FETCH_INVENTORY_ITEMS_TEMPLATE_DOWNLOAD_URL'
);
